import { en, pt } from './locales';

import './fontawesome';
import './shared/style/index.scss';

import authReducer from './auth/reducers';
import { authSagas } from './auth/sagas';
import usersReducer from './users/reducers';
import { userSagas } from './users/sagas';
import entitiesReducer from './entities/reducers';
import { entitySagas } from './entities/sagas';
import rolesReducer from './roles/reducers';
import { billingReportSagas } from './billingReport/sagas';
import billingReportReducer from './billingReport/reducers';
import { roleSagas } from './roles/sagas';
import rulesReducer from './rules/reducers';
import { ruleSagas } from './rules/sagas';
import terminalsReducer from './terminals/reducers';
import { terminalSagas } from './terminals/sagas';
import interfacesReducer from "./interfaces/reducers";
import { interfaceSagas } from './interfaces/sagas';
import entityInterfacesReducer from "./entityInterfaces/reducers";
import { entityInterfaceSagas } from './entityInterfaces/sagas';
import dashboardAndWidgetsReducer from './dashboard/reducers';
import { dashboardSagas } from './dashboard/sagas';

import sharedReducer from './shared/reducers';

let rootReducer = {
    authReducer,
    usersReducer,
    entitiesReducer,
    rolesReducer,
    rulesReducer,
    billingReportReducer,
    terminalsReducer,
    interfacesReducer,
    entityInterfacesReducer,
    dashboardAndWidgetsReducer,
    sharedReducer
};

let sagas = [
    ...authSagas,
    ...userSagas,
    ...entitySagas,
    ...roleSagas,
    ...ruleSagas,
    ...billingReportSagas,
    ...terminalSagas,
    ...interfaceSagas,
    ...entityInterfaceSagas,
    ...dashboardSagas,
];

let locales = {
    'en': en,
    'pt': pt
};

export {
    rootReducer,
    sagas,
    locales
}